var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHiringPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 275,
    viewBox: "0 0 275 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.174 65.5183C123.174 65.5183 123.172 65.407 123.149 65.2056C122.992 63.7828 121.849 57.8635 113.641 54.9071C104.272 51.5321 96.6927 59.4558 96.1064 66.5439C95.6237 72.3791 90.5562 71.9076 84.1057 71.5568C77.6552 71.206 69.8348 76.4543 71.7136 85.5056C73.5923 94.5568 98.7256 108.609 104.183 101.589C109.64 94.5704 107.404 85.7037 111.109 79.715L123.174 65.5183Z",
    fill: "#404B7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.054 110.517L102.054 110.517C100.264 105.077 102.829 99.0766 105.9 94.3907C107.431 92.0556 109.075 90.0641 110.338 88.6559C110.969 87.9521 111.505 87.3946 111.882 87.0134C112.066 86.8271 112.212 86.683 112.314 86.5845C113.19 87.5229 114.221 89.3197 115.316 91.6983C116.471 94.208 117.685 97.3346 118.851 100.709C121.185 107.46 123.326 115.187 124.438 120.93L124.486 121.177L124.728 121.106L138.523 117.043L138.523 117.043L143.336 115.628C143.364 115.654 143.398 115.686 143.437 115.723C143.563 115.842 143.744 116.017 143.965 116.24C144.407 116.686 145.006 117.322 145.635 118.079C146.869 119.566 148.2 121.498 148.71 123.383C148.665 123.421 148.606 123.471 148.535 123.531C148.348 123.689 148.074 123.919 147.723 124.211C147.021 124.794 146.012 125.624 144.783 126.609L144.783 126.609C141.392 129.331 136.335 133.236 131.486 136.394C129.061 137.973 126.693 139.362 124.615 140.322C122.525 141.288 120.768 141.802 119.549 141.678L119.549 141.678C117.894 141.51 116.192 140.221 114.498 138.129C112.812 136.046 111.17 133.211 109.628 130.04C106.544 123.701 103.876 116.062 102.054 110.517Z",
    fill: "#60B0F4",
    stroke: "#60B0F4",
    strokeWidth: 0.458333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.445 122.093C124.445 122.093 121.283 131.13 120.139 134.722",
    stroke: "#60B0F4",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.723 124.211C147.059 124.763 146.12 125.535 144.981 126.45L138.818 116.956L143.336 115.628C143.364 115.654 143.398 115.686 143.437 115.723C143.563 115.842 143.744 116.017 143.965 116.24C144.407 116.686 145.006 117.322 145.635 118.079C146.869 119.566 148.2 121.498 148.71 123.383C148.665 123.421 148.606 123.471 148.535 123.531C148.348 123.689 148.074 123.919 147.723 124.211Z",
    fill: "#9AB3DA",
    stroke: "#60B0F4",
    strokeWidth: 0.458333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0699 173.801L26.9529 239.907C26.7037 241.389 27.8459 242.739 29.3484 242.739H29.3484C30.4275 242.739 31.3772 242.027 31.6799 240.992L51.3192 173.801H38.0699Z",
    fill: "#9AB3DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8687 173.801L50.7517 239.907C50.5026 241.389 51.6447 242.739 53.1472 242.739H53.1472C54.2263 242.739 55.1761 242.027 55.4788 240.992L75.1181 173.801H61.8687Z",
    fill: "#404B7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.37 173.801L127.487 239.907C127.736 241.389 126.594 242.739 125.091 242.739H125.091C124.012 242.739 123.062 242.027 122.76 240.992L103.12 173.801H116.37Z",
    fill: "#404B7C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5708 173.801L103.688 239.907C103.937 241.389 102.795 242.739 101.292 242.739H101.292C100.213 242.739 99.2634 242.027 98.9607 240.992L79.3214 173.801H92.5708Z",
    fill: "#9AB3DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101.142 169.66H31.9972V86.7231H76.6496C80.039 86.7231 82.7865 89.4707 82.7865 92.8601V153.141C82.7865 159.887 87.2829 165.805 93.7814 167.613L101.142 169.66Z",
    fill: "#404B7C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5925 93.2614C38.448 86.1005 28.5182 84.1565 25.8319 90.796C20.6703 103.554 22.8883 126.634 22.8883 143.714C22.8883 168.556 27.8568 180.702 57.6679 180.702C57.6679 180.702 84.4427 180.702 95.4839 180.702C106.525 180.702 105.421 166.9 96.0359 166.9C86.6509 166.9 57.6679 166.9 50.7672 166.9C43.8665 166.9 39.45 161.103 39.45 147.026C39.45 137.253 38.9179 109.389 38.5925 93.2614Z",
    fill: "#6B81BE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.743 180.701H80.0167C77.0092 180.701 74.5712 178.263 74.5712 175.256V172.345C74.5712 169.338 77.0092 166.9 80.0167 166.9H118.743C121.751 166.9 124.189 169.338 124.189 172.345V175.256C124.189 178.263 121.751 180.701 118.743 180.701Z",
    fill: "#404B7C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.881 209.961H131.356C131.356 209.961 131.356 224.038 142.963 231.629C150.393 236.489 148.11 242.739 148.11 242.739H130.252L122.577 234.182L122.247 242.739H116.716C116.206 229.421 118.881 209.961 118.881 209.961Z",
    fill: "#404B7C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.046 239.164L122.577 234.182L122.392 238.978",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.594 221.502C118.202 214.899 118.881 209.961 118.881 209.961H131.356",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8007 165.341C96.182 166.288 99.5376 166.782 102.803 166.979L115.53 167.014L107.434 219.472H139.971C139.971 219.472 142.83 164.29 143.875 156.321C144.927 148.364 139.577 143.433 129.942 142.492C126.126 142.12 115.175 141.644 109.413 141.208L100.262 125.159L76.0279 133.025C76.0279 133.025 74.9708 159.585 93.8007 165.341Z",
    fill: "#9AB3DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5919 151.658L124.207 154.625L116.058 213.116",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.289 214.343H110.325",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7739 131.441L84.7385 141.629C85.1717 143.118 84.7907 144.726 83.7351 145.862L82.6477 147.032",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4275 209.961H90.2967C90.2967 209.961 90.8488 226.937 96.5074 231.629C102.166 236.322 100.372 242.739 100.372 242.739H84.7242L82.4299 234.182L82.1819 242.739H76.802C76.4186 229.421 78.4275 209.961 78.4275 209.961Z",
    fill: "#404B7C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2448 165.341C67.6261 166.288 70.9817 166.782 74.2474 166.979L81.9589 167.014L73.8627 219.472H106.4C106.4 219.472 109.259 164.29 110.304 156.321C111.355 148.364 106.006 143.433 96.3705 142.492C92.5545 142.12 86.6187 141.644 80.857 141.208L78.1098 133.025L49.9459 133.713C49.9459 133.713 46.4149 159.585 65.2448 165.341Z",
    fill: "#9AB3DA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.527 165.513C109.831 161.175 110.102 157.863 110.304 156.321C111.355 148.364 106.006 143.433 96.3705 142.492",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4157 131.956C64.4157 131.956 67.4457 141.272 60.5104 143.653",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1809 141.479C80.1809 141.479 71.6164 142.308 68.1353 144.999",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2366 131.956L62.0665 151.658L90.6355 154.625L82.4867 213.116",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.718 214.343H76.7534",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6707 219.472H100.251",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4613 136.991C57.0432 90.4465 78.9481 79.4796 78.9481 79.4796C78.9481 79.4796 92.4872 74.1569 99.2555 76.549C111.833 80.9943 113.093 88.2749 113.093 88.2749C113.093 88.2749 116.139 99.2786 114.265 103.688C112.392 108.097 103.076 119.532 103.076 119.532C103.236 126.262 105.929 133.396 109.649 140.694C109.649 140.694 77.6027 150.567 47.4613 136.991Z",
    fill: "#60B0F4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5572 84.4744C92.6088 86.0295 94.4517 87.8265 97.6174 88.794C103.949 90.7289 107.111 88.0966 107.111 88.0966L109.973 83.8027",
    fill: "#60B0F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5572 84.4744C92.6088 86.0295 94.4517 87.8265 97.6174 88.794C103.949 90.7289 107.111 88.0966 107.111 88.0966L109.973 83.8027",
    stroke: "#60B0F4",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.587 75.6579C97.5865 71.4847 92.5261 72.7143 91.1789 74.7604C89.8317 76.8066 92.8194 83.3128 101.904 85.4226C110.989 87.5324 114.278 80.1914 105.587 75.6579Z",
    fill: "#60B0F4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1789 74.7603C89.8317 76.8064 92.8194 83.3127 101.904 85.4225C106.574 86.5069 109.713 85.0943 110.48 82.8495",
    fill: "#60B0F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1789 74.7603C89.8317 76.8064 92.8194 83.3127 101.904 85.4225C106.574 86.5069 109.713 85.0943 110.48 82.8495",
    stroke: "#60B0F4",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3192 134.722C51.3192 134.722 78.6323 144.998 105.945 137.804L51.3192 134.722Z",
    fill: "#60B0F4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3192 134.722C51.3192 134.722 78.6323 144.998 105.945 137.804",
    stroke: "#60B0F4",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.093 88.2749C113.093 88.2749 116.139 99.2786 114.265 103.688C112.772 107.203 106.191 115.255 103.981 118.297",
    fill: "#60B0F4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M113.093 88.2749C113.093 88.2749 116.139 99.2786 114.265 103.688C112.772 107.203 106.191 115.255 103.981 118.297",
    stroke: "#60B0F4",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.389 15.6011V18.025",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.389 20.6125V23.0365",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1066 19.3188H43.6826",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0953 19.3188H38.6713",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0171 43.625V45.6538",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0171 47.8196V49.8484",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1287 46.7368H77.0999",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9343 46.7368H72.9054",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M193.477 80.657V82.6858",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.477 84.8518V86.8806",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M196.589 83.769H194.56",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M192.394 83.769H190.365",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M160.545 199.699V201.067",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M160.545 202.526V203.894",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M162.642 201.797H161.275",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M159.815 201.797H158.448",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M238.198 24.0774V26.6165",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M238.198 29.3269V31.866",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M242.092 27.9719H239.553",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M236.843 27.9719H234.304",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0253 71.3044C27.1366 71.3044 28.0375 70.4035 28.0375 69.2922C28.0375 68.1809 27.1366 67.28 26.0253 67.28C24.914 67.28 24.0131 68.1809 24.0131 69.2922C24.0131 70.4035 24.914 71.3044 26.0253 71.3044Z",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M201.258 158.989C202.369 158.989 203.27 158.088 203.27 156.977C203.27 155.866 202.369 154.965 201.258 154.965C200.147 154.965 199.246 155.866 199.246 156.977C199.246 158.088 200.147 158.989 201.258 158.989Z",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8937 47.6633C40.6707 47.6633 41.3006 47.0335 41.3006 46.2565C41.3006 45.4795 40.6707 44.8496 39.8937 44.8496C39.1167 44.8496 38.4868 45.4795 38.4868 46.2565C38.4868 47.0335 39.1167 47.6633 39.8937 47.6633Z",
    fill: "#E9F3FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M157.005 177.005C158.774 177.005 160.209 175.571 160.209 173.801C160.209 172.031 158.774 170.597 157.005 170.597C155.235 170.597 153.801 172.031 153.801 173.801C153.801 175.571 155.235 177.005 157.005 177.005Z",
    fill: "#E9F3FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M226.501 55.925C227.848 55.925 228.94 54.833 228.94 53.486C228.94 52.1389 227.848 51.0469 226.501 51.0469C225.154 51.0469 224.062 52.1389 224.062 53.486C224.062 54.833 225.154 55.925 226.501 55.925Z",
    fill: "#E9F3FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M201.158 242.739H252.586",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5448 242.74H188.816",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6474 251.58H52.9476",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M234.574 251.58H87.0154",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M162.922 260.421H180.339",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8481 260.421H157.174",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M108.035 79.8104L103.755 81.7629C103.507 81.7675 103.273 81.7583 103.04 81.7445C99.318 81.5658 97.338 79.7187 96.568 78.7883L104.419 74.2187L107.105 72.6604L108.035 79.8104Z",
    fill: "#ECBDBB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M108.035 79.8104L103.755 81.7629C103.507 81.7675 103.273 81.7583 103.04 81.7445C101.683 78.9029 102.943 76.162 104.419 74.2187L107.105 72.6604L108.035 79.8104Z",
    fill: "#404B7C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M114.426 63.2214C108.201 64.2883 99.9396 79.4425 109.032 83.4203C118.124 87.3982 127.108 61.048 114.426 63.2214Z",
    fill: "#ECBDBB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M104.023 74.1616C104.023 74.1616 107.387 70.2163 110.634 68.1623C110.634 68.1623 115.012 73.6059 120.4 73.5113C125.788 73.4167 131.6 65.1256 128.127 61.922C124.653 58.7184 121.056 62.0577 121.056 62.0577C121.056 62.0577 105.18 50.9378 104.023 74.1616Z",
    fill: "#404B7C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M106.472 73.4163C106.472 73.4163 106.989 67.0075 101.867 66.5783C96.7454 66.1491 98.0143 76.591 105.798 75.9084L106.472 73.4163Z",
    fill: "#ECBDBB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M104.174 74.1839C104.048 74.1411 103.955 74.0247 103.949 73.884C103.947 73.8457 103.748 70.0651 101.093 68.6862C100.93 68.6018 100.866 68.4012 100.951 68.2383C101.035 68.0747 101.237 68.0124 101.399 68.0964C104.399 69.6539 104.606 73.6841 104.613 73.855C104.621 74.0384 104.479 74.1933 104.295 74.2011C104.253 74.2031 104.212 74.1969 104.174 74.1839Z",
    fill: "#404B7C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M101.821 72.7426C101.652 72.6848 101.558 72.5026 101.611 72.3301C101.625 72.287 101.954 71.2577 103.14 70.2955C103.282 70.1797 103.492 70.201 103.607 70.344C103.723 70.4864 103.701 70.6958 103.559 70.8114C102.539 71.6389 102.248 72.5199 102.246 72.5286C102.19 72.703 102.003 72.7999 101.829 72.745C101.826 72.7444 101.824 72.7435 101.821 72.7426Z",
    fill: "#404B7C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M110.127 71.5836C110.127 71.5836 111.937 69.9387 113.18 71.3246C113.18 71.3246 113.404 70.8774 113.813 71.026C114.222 71.1746 113.766 72.4581 113.766 72.4581C113.766 72.4581 111.967 71.5758 110.127 71.5836Z",
    fill: "#404B7C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M118.452 75.9691C118.452 75.9691 119.143 73.8416 117.716 73.9475C117.716 73.9475 117.836 73.5517 117.593 73.4064C117.172 73.1549 116.612 74.3125 116.612 74.3125C116.612 74.3125 117.897 74.8436 118.452 75.9691Z",
    fill: "#404B7C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M112.219 75.2121C112.466 74.6359 112.288 74.0068 111.822 73.807C111.356 73.6072 110.778 73.9123 110.531 74.4886C110.284 75.0648 110.461 75.694 110.927 75.8938C111.394 76.0936 111.972 75.7884 112.219 75.2121Z",
    fill: "#404B7C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M111.719 74.8042C111.854 74.8042 111.964 74.6949 111.964 74.5601C111.964 74.4252 111.854 74.3159 111.719 74.3159C111.585 74.3159 111.475 74.4252 111.475 74.5601C111.475 74.6949 111.585 74.8042 111.719 74.8042Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.19 77.3432C117.437 76.767 117.26 76.1379 116.794 75.9381C116.327 75.7383 115.749 76.0434 115.502 76.6197C115.255 77.1959 115.433 77.8251 115.899 78.0249C116.365 78.2247 116.943 77.9195 117.19 77.3432Z",
    fill: "#404B7C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M116.691 76.9353C116.826 76.9353 116.935 76.826 116.935 76.6912C116.935 76.5563 116.826 76.447 116.691 76.447C116.556 76.447 116.447 76.5563 116.447 76.6912C116.447 76.826 116.556 76.9353 116.691 76.9353Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M112.903 79.7065C112.645 79.6186 112.42 79.4887 112.267 79.3723C112.121 79.2614 112.093 79.0537 112.203 78.9074C112.313 78.7615 112.522 78.7319 112.668 78.842C112.677 78.8482 113.463 79.4287 113.919 78.9662C114.017 78.8663 114.007 78.8128 114.003 78.7922C113.964 78.589 113.54 78.3028 113.249 78.174C113.083 78.101 113.006 77.9081 113.076 77.7413L113.936 75.6938C114.007 75.5244 114.202 75.4488 114.371 75.5157C114.54 75.5868 114.62 75.7816 114.549 75.9509L113.809 77.7142C114.125 77.8966 114.571 78.226 114.656 78.667C114.693 78.8575 114.676 79.1449 114.392 79.4334C113.945 79.886 113.371 79.8658 112.903 79.7065Z",
    fill: "#404B7C"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M112.135 81.5956C112.135 81.5956 109.278 82.1683 108.946 78.7961L112.135 81.5956Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M114.312 118.372L118.436 116.267L119.315 107.774C119.48 106.183 120.723 104.919 122.31 104.727L136.682 102.989C137.424 102.899 138.077 103.478 138.077 104.225C138.077 104.81 137.669 105.316 137.098 105.441L130.938 106.79L131.844 113.953C131.994 115.145 131.344 116.295 130.244 116.78L128.188 117.685L128.085 118.088C127.58 120.065 125.893 121.516 123.863 121.721L122.993 121.809L118.651 125.719L114.312 118.372Z",
    fill: "#6B81BE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M124.9 107.535L130.293 106.79",
    stroke: "#404B7C",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M125.141 110.655L130.497 109.717",
    stroke: "#404B7C",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M125.74 113.332L130.924 112.329",
    stroke: "#404B7C",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1372 105.42C72.7526 116.522 84.0891 143.466 91.0916 144.175C96.2376 144.698 109.707 134.504 116.493 129.057C118.952 127.086 120.534 125.733 120.534 125.733C119.545 121.774 114.962 117.641 114.962 117.641L110.024 119.093L96.2294 123.156C93.9985 111.645 84.4571 82.6031 80.6881 78.9312C80.6881 78.9312 61.859 83.0698 69.1372 105.42Z",
    fill: "#60B0F4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M109.147 119.351L96.2294 123.155C94.355 113.484 87.3201 91.438 82.884 82.4604",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9706 88.4531C67.1999 92.3899 66.6768 97.8642 69.1372 105.42C72.7526 116.522 84.0891 143.466 91.0916 144.175C95.9464 144.669 108.209 135.624 115.279 130.024",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0111 124.362C96.0111 124.362 92.8489 133.399 91.7053 136.991",
    stroke: "#6B81BE",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M110.024 119.093L116.493 129.057C118.952 127.086 120.534 125.734 120.534 125.734C119.545 121.774 114.962 117.641 114.962 117.641L110.024 119.093Z",
    fill: "#9AB3DA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M151.116 132.278L167.43 96.4194H143.717L127.404 132.278H151.116Z",
    fill: "#6B81BE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M146.341 105.243L148.285 101.211C148.949 99.8331 148.134 98.6613 146.752 99.0073C146.007 99.1938 145.299 99.7901 144.941 100.533L142.997 104.565C142.333 105.943 143.148 107.115 144.53 106.769H144.53C145.275 106.582 145.983 105.986 146.341 105.243Z",
    fill: "#404B7C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M164.77 93.7605L167.43 96.4197H143.717L141.058 93.7605H164.77Z",
    fill: "#DEEBFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M127.404 132.279L124.745 129.619L141.058 93.7605L143.717 96.4197L127.404 132.279Z",
    fill: "#9AB3DA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M159.401 107.697C154.419 107.176 150.879 109.899 153.33 111.144C153.33 111.144 149.981 111.899 151.859 114.595C151.859 114.595 148.609 115.901 150.602 118.434C150.602 118.434 148.02 120.719 151.451 121.904C154.882 123.09 159.047 122.715 158.721 119.635C158.721 119.635 162.723 118.76 161.498 115.33C161.498 115.33 163.703 114.595 162.968 111.817C162.968 111.817 167.771 108.573 159.401 107.697Z",
    fill: "#ECBDBB"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M154.337 111.021C154.337 111.021 159.619 110.093 162.233 111.727",
    stroke: "#404B7C",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M153.03 114.777C153.03 114.777 158.421 114.332 160.545 115.371",
    stroke: "#404B7C",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M151.614 118.589C151.614 118.589 155.807 118.044 157.931 119.351",
    stroke: "#404B7C",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M223.915 145.557H176.318C174.235 145.557 172.546 143.868 172.546 141.785V114.36C172.546 112.277 174.235 110.588 176.318 110.588H223.915C225.998 110.588 227.687 112.277 227.687 114.36V141.785C227.687 143.868 225.998 145.557 223.915 145.557Z",
    fill: "#9AB3DA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M221.811 140.692H205.699C204.823 140.692 204.113 139.982 204.113 139.106V122.989C204.113 122.113 204.823 121.403 205.699 121.403H221.811C222.687 121.403 223.397 122.113 223.397 122.989V139.106C223.397 139.982 222.687 140.692 221.811 140.692Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M221.934 118.379H205.576C204.768 118.379 204.113 117.724 204.113 116.916V116.916C204.113 116.108 204.768 115.453 205.576 115.453H221.934C222.742 115.453 223.397 116.108 223.397 116.916V116.916C223.397 117.724 222.742 118.379 221.934 118.379Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M188.545 126.656C191.726 126.656 194.305 124.077 194.305 120.895C194.305 117.714 191.726 115.135 188.545 115.135C185.364 115.135 182.785 117.714 182.785 120.895C182.785 124.077 185.364 126.656 188.545 126.656Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M200.255 141.01H176.836C176.836 134.545 182.079 129.302 188.544 129.302C195.011 129.302 200.255 134.545 200.255 141.01Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M245.803 99.7281H209.584C207.859 99.7281 206.46 98.3292 206.46 96.6035V75.9205C206.46 74.1948 207.859 72.7959 209.584 72.7959H245.803C247.529 72.7959 248.928 74.1948 248.928 75.9205V96.6035C248.928 98.3292 247.529 99.7281 245.803 99.7281Z",
    fill: "#9AB3DA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M244.038 95.9812H232.358C231.482 95.9812 230.772 95.271 230.772 94.3949V82.7115C230.772 81.8355 231.482 81.1252 232.358 81.1252H244.038C244.914 81.1252 245.624 81.8355 245.624 82.7115V94.3949C245.624 95.271 244.914 95.9812 244.038 95.9812Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M244.497 78.7959H231.899C231.276 78.7959 230.772 78.2914 230.772 77.6692C230.772 77.0469 231.276 76.5425 231.899 76.5425H244.497C245.12 76.5425 245.624 77.0469 245.624 77.6692C245.624 78.2914 245.12 78.7959 244.497 78.7959Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M218.782 85.1707C221.232 85.1707 223.218 83.1845 223.218 80.7343C223.218 78.2841 221.232 76.2979 218.782 76.2979C216.332 76.2979 214.345 78.2841 214.345 80.7343C214.345 83.1845 216.332 85.1707 218.782 85.1707Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M227.8 96.2262H209.764C209.764 91.2475 213.802 87.2092 218.781 87.2092C223.762 87.2092 227.8 91.2475 227.8 96.2262Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M211.786 205.491C211.786 205.491 204.449 163.66 244.87 154.965C244.87 154.965 252.493 195.386 211.786 205.491Z",
    fill: "#6B81BE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M214.709 201.026L241.946 159.43",
    stroke: "#9AB3DA",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M212.739 203.648C212.739 203.648 215.123 169.015 182.128 161.817C182.128 161.817 179.398 195.281 212.739 203.648Z",
    fill: "#9AB3DA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M210.034 199.951L184.833 165.513",
    stroke: "#DEEBFF",
    strokeWidth: 0.458333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M237.883 224.671C237.26 227.683 236.403 230.735 235.234 233.687C233.969 236.891 232.342 239.971 230.252 242.739H197.252C191.669 235.341 189.378 225.712 188.53 217.489C187.544 207.924 188.511 200.265 188.511 200.265H238.997C238.997 200.265 240.491 212.067 237.883 224.671Z",
    fill: "#60B0F4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M237.883 224.671C237.26 227.683 236.403 230.735 235.234 233.687C232.745 230.075 227.814 226.615 218.088 227.71C205.08 229.172 194.364 224.662 188.53 217.489C187.544 207.924 188.511 200.265 188.511 200.265H199.736C202.413 205.779 208.747 213.791 223.065 214.638C232.081 215.175 236.183 219.611 237.883 224.671Z",
    fill: "#7A8996"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M220.375 233.263C209.729 234.651 212.735 242.26 222.521 239.907C231.125 237.837 226.224 232.501 220.375 233.263Z",
    fill: "#EFF7FE"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M206.353 66.2352H147.165C144.845 66.2352 142.963 64.354 142.963 62.0335V27.5725C142.963 25.252 144.845 23.3708 147.165 23.3708H206.353C208.673 23.3708 210.554 25.252 210.554 27.5725V62.0335C210.554 64.354 208.673 66.2352 206.353 66.2352Z",
    fill: "#9AB3DA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M203.71 60.2717H183.244C182.368 60.2717 181.658 59.5615 181.658 58.6854V38.2137C181.658 37.3376 182.368 36.6274 183.244 36.6274H203.71C204.586 36.6274 205.296 37.3376 205.296 38.2137V58.6854C205.296 59.5615 204.586 60.2717 203.71 60.2717Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M203.71 32.9204H183.244C182.368 32.9204 181.658 32.2102 181.658 31.3341V30.9203C181.658 30.0442 182.368 29.334 183.244 29.334H203.71C204.586 29.334 205.296 30.0442 205.296 30.9203V31.3341C205.296 32.2102 204.586 32.9204 203.71 32.9204Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M162.575 43.0661C166.474 43.0661 169.636 39.9048 169.636 36.0052C169.636 32.1056 166.474 28.9443 162.575 28.9443C158.675 28.9443 155.514 32.1056 155.514 36.0052C155.514 39.9048 158.675 43.0661 162.575 43.0661Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M176.928 60.6616H148.222C148.222 52.7377 154.649 46.3105 162.573 46.3105C170.501 46.3105 176.928 52.7377 176.928 60.6616Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M147.374 15.5876L149.063 20.7857H154.529C155.943 20.7857 156.531 22.5954 155.387 23.4267L150.965 26.6393L152.654 31.8373C153.091 33.1823 151.552 34.3008 150.408 33.4695L145.986 30.257L141.564 33.4695C140.42 34.3008 138.881 33.1823 139.318 31.8373L141.007 26.6393L136.585 23.4267C135.441 22.5954 136.029 20.7857 137.443 20.7857H142.909L144.597 15.5876C145.035 14.2426 146.937 14.2426 147.374 15.5876Z",
    fill: "#60B0F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringPeople);
export default __webpack_public_path__ + "static/media/HiringPeople.852c508110c8555cfca890892f022726.svg";
export { ForwardRef as ReactComponent };